// If user doesn't have premium tools access then no ajax_url will be passed
export default function PremiumToolNotification({ children }) {
	const premiumTool = window?.wpObject?.ajax_url == null;
	return (
		<>
			{
				premiumTool &&
				<div class="cok-preimum-tool-alert">
					<div class="row">
						<div class="margin-lg">
							<span class="cok-preimum-tool-alert-text">
								<i class="fas fa-star"></i>
								<span>Det här är ett premiumverktyg och du behöver ett premiumabonnemang för att använda det.</span>
							</span>
							{/* <div class="wp-block-button has-custom-font-size big has-small-font-size">
								<a class="wp-block-button__link" href={window.wpObject.subscribe_link != null ? window.wpObject.subscribe_link : "" }>Become a subscriber here.</a>
							</div> */}
						</div>
					</div>
					
				</div>
			}
		<fieldset disabled={premiumTool}>
			{children}
		</fieldset>
		</>
	);
}
